export const radii = {
  none: '0', // 0px
  sm: '0.125rem', // 2px
  md: '0.25rem', // 4px
  lg: '0.5rem', // 8px
  xl: '1rem', // 16px
  full: '9999px', // high enough to apply full rounding
} as const;
